import { lazyLoad } from '@/lib/LazyLoad';

export const SignUpPage = lazyLoad(
  () => import('./SignUp'),
  (module) => module.SignUp
);
